import { render, staticRenderFns } from "./UploadMendi.vue?vue&type=template&id=4a3a25af&scoped=true&"
import script from "./UploadMendi.vue?vue&type=script&lang=js&"
export * from "./UploadMendi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3a25af",
  null
  
)

export default component.exports